import './prompt.css'
import React from 'react';
import { MessageAPI } from '../../apis/message/MessageAPI';

const Prompt = (props) => {
    const TYPE_RESPONSE = 'response'
    const { updateChatLog, setIsLoading, isLoading , signal } = props
    var myFormRef;

    const onEnterPress = (e) => {
        if(e.keyCode === 13 && e.shiftKey === false) {
            e.preventDefault();
            myFormRef.requestSubmit();
        }
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        const message = e.target.firstChild?.value
        e.target.reset();
        updateChatLog(chatlog => [
            ...chatlog,
            { 
                message: {
                    type: 'question',
                    content: message,
                    timestamp: Date.now(),
                    id: null
                }
            }
        ], sendMessageToAPI(message));
    }

    const sendMessageToAPI = (message) => {
        setIsLoading(true);
        MessageAPI.sendMessage(message ?? '', signal)
            .then((responseData) => {
                if (responseData) {
                    setIsLoading(false)
                    updateChatLog(chatlog => [
                        ...chatlog,
                        { 
                            message: {
                                type: TYPE_RESPONSE,
                                content: responseData.content,
                                timestamp: responseData.timestamp,
                                id: responseData.id
                            } 
                        } 
                        
                    ]);

                }
            })
            .catch((err) => {
                setIsLoading(false);
                if (err.name === "CanceledError") {
                    console.log('najs');
                }
            })
        ;
    }

    return <div className="prompt-container">
                <form ref={el => myFormRef = el} className="prompt-form" onSubmit={handleSubmit} >
                    <textarea 
                        type="text" 
                        rows="3" 
                        name="body" 
                        onKeyDown={onEnterPress} 
                        disabled={isLoading} 
                        placeholder='Start typing your question here...'
                    />
                    <button className="btn btn--primary prompt-btn" type="submit" disabled={isLoading} >Send</button>
                </form>
            </div>;  
    
    
}

export default Prompt;
